import i18n from '@/i18n/i18n.js'

const { t } = i18n.global

export const FARMER_DOCUMENT_CATEGORY = {
  OFFICIAL_IDENTITY: 1,
  RESIDENCE: 2,
  FARMER_REGISTRY: 3,
  APPLICATION_DOCUMENT: 4,
  FARMER_VERIFICATION: 5
}

export const FARMER_DOCUMENT_CATEGORY_MAP = {
  [FARMER_DOCUMENT_CATEGORY.OFFICIAL_IDENTITY]: t('constants.farmer_document_category.official_identity'),
  [FARMER_DOCUMENT_CATEGORY.RESIDENCE]: t('constants.farmer_document_category.residence'),
  [FARMER_DOCUMENT_CATEGORY.FARMER_REGISTRY]: t('constants.farmer_document_category.farmer_registry'),
  [FARMER_DOCUMENT_CATEGORY.APPLICATION_DOCUMENT]: t('constants.farmer_document_category.application_document'),
  [FARMER_DOCUMENT_CATEGORY.FARMER_VERIFICATION]: t('constants.farmer_document_category.farmer_verification')
}
